import o from"./_getNative.js";import r from"./_root.js";var t=o(r,"Map");export{t as default};
//# sourceMappingURL=_Map.js.map
